import React, { useState, useRef, useEffect } from 'react'
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { Link } from 'react-router-dom';

import './names.css';


const NamesInGrid = ( { row, contacts } ) => {
    const [ pri, setPri ] = useState( { cid: '', name: '' } );
    const [ assocs, setAssocs ] = useState( [] );

    const [show, setShow] = useState(false);
    const handleOnMouseEnter = () => {
        setShow( true );
    }
    const handleOnMouseLeave = () => {
        setShow( false );
    }

    const ref = useRef();

    useEffect( () => {
        if ( row.assoc && row.assoc.length && row.assoc[0] ) {
            let assocs = [];
            row.assoc.forEach( a => {
                const c = contacts[a.cid]; // cl.find( f => f.cid === a.cid );
                if ( c ) {
                    assocs.push( { cid: c.cid, name: `${c.firstname} ${c.lastname}` } );
                }
            } );
            setAssocs( assocs );
            if ( assocs.length ) { setPri( assocs[0] ); }
        } else if ( row.c ) {
            setPri( row.c );
        }
    }, [ row, row.assoc, contacts ] );
    
    const popup = (
        <Popover id="popover-basic" style={ { width: '300px', zIndex: '9999' } } onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave}>
            <Popover.Header as="h3">Contacts</Popover.Header>
            <Popover.Body>
                { 
                    assocs.map( b => {
                        return (
                            <Row key={b.cid} className='text-start py-1' style={ { fontSize: '12px' } }>
                                <Col className='ps-0'><Link to={`/contact/${b.cid}`}>{b.name}</Link></Col>
                            </Row>
                        )
                    } ) 
                }
            </Popover.Body>
        </Popover>
    );

    return (
        <Container>
            <Row className='p-0'>
                <Col xs='auto' className='p-0 pe-2'><Link to={`/contact/${pri.cid}`}>{pri.name}</Link></Col>
                {
                    assocs.length > 1
                    &&  <OverlayTrigger placement="right" overlay={popup} show={show} container={ref}>
                            <Col xs='auto' className='tf-multi-contact-badge ps-1 align-items-center' ref={ref} onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave}>+{assocs.length - 1}</Col>
                        </OverlayTrigger>
                }
            </Row>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    contacts: state.contacts.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( NamesInGrid );